import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { FlowParamsContext } from './FlowParamsProvider';

type FlowParams = {
  flowType: string;
  resourceType: 'source' | 'sink';
  id: string | number;
  nexsetId?: number;
  sourceId?: number;
  isModal: boolean;
  onDismiss: (data?: any) => void;
  queryParams?: Record<string, any>;
};

type UseParams = {
  flowType: string;
  resourceType: 'source' | 'sink';
  id: string;
};

export default function useFlowParams(): FlowParams {
  const {
    flowType: propFlowType,
    resourceType: propResourceType,
    id: propId,
    nexsetId: propNexsetId,
    sourceId: propSourceId,
    isModal,
    onDismiss,
    queryParams: propQueryParams,
  } = useContext(FlowParamsContext);

  const {
    flowType: paramFlowType,
    resourceType: paramResourceType,
    id: paramId,
  } = useParams<UseParams>();

  if (isModal) {
    return {
      flowType: propFlowType,
      resourceType: propResourceType,
      id: propId,
      nexsetId: propNexsetId,
      sourceId: propSourceId,
      isModal,
      onDismiss,
      queryParams: propQueryParams,
    };
  }

  return {
    flowType: paramFlowType,
    resourceType: paramResourceType,
    id: paramId,
    nexsetId: propNexsetId,
    sourceId: propSourceId,
    isModal,
    onDismiss,
    queryParams: propQueryParams,
  };
}
